export default __webpack_public_path__ + "static/media/pantry1-afterA-1024w.90abbcc0.png";